import React, { Component } from "react";
import { Button, Modal, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import FloatingButton from "../../Material/FloatingButton";
import { connect } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import "react-toastify/dist/ReactToastify.css";
import SimpleReactValidator from "simple-react-validator";
import { apiFetch } from "../../../apiFetch";

toast.configure();
class Accessprivilegecreate extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator1 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.state = {
      SectionlistArray: [],
      StaffDetailslistArray: [],
      popupSection: "",
      Custodian: "",
      multicustodianvalue: "",
      id: "0",
      Role: "",
      popupEmployeeId: "",
      popupEmployeeName: "",
      activestatus: "1",
      Inspectedbypopup: false,
      stafflistArraySpin: "none",
      userRole: this.props.userType,
      checkmulti: [],
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: "headerTitle",
      value: "Access Privilege: Create",
    });
    this.loginemployeename();
    this.GetSectionListData();
  }

  _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.searchEmployee();
    }
  };

  saveaccess = () => {
    if (this.state.Role !== "FocalAdmin") {
      if (this.validator.allValid()) {
        let postData = {
          Mode: "Add",
          Role: this.state.Role,
          EmployeeID: this.state.Inspectedby,
          CreatedBy: this.props.UserId,
          Active: this.state.activestatus,
        };

        apiFetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            "/api/AccessPrivilege/InsertUpdateAccessPrivileges",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
            }
          })

          .then((data) => {
            console.log(data);
            if (data) {
              if (data.Status === "Success") {
                this.setState({
                  Role: "",
                  Inspectedby: "",
                  Inspectedbyname: "",
                  Custodian: "",
                });
                toast.success("Created successfully.", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
                this.validator.hideMessages();
                localStorage.setItem("firststatus", "yes");
                this.props.history.push({ pathname: "/Access/AccessList" });
              } else {
                toast.error(data.Message, {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
              }
            }
          })
          .catch((error) => {
            console.log(error);
            // this.props.history.push({pathname:"/somethingwrong"})
          });
      } else {
        this.validator.showMessages();
        this.forceUpdate();
      }
    } else {
      if (this.validator1.allValid()) {
        let postData = {
          Mode: "Add",
          Role: this.state.Role,
          EmployeeID: this.state.Inspectedby,
          Custodian: this.state.Custodian,
          CreatedBy: this.props.UserId,
          Active: this.state.activestatus,
        };

        apiFetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            "/api/AccessPrivilege/InsertUpdateAccessPrivileges",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
            }
          })

          .then((data) => {
            console.log(data);
            if (data) {
              if (data.Status === "Success") {
                this.setState({
                  Role: "",
                  Inspectedby: "",
                  Inspectedbyname: "",
                  Custodian: "",
                });
                toast.success("Created successfully.", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
                this.validator1.hideMessages();
                localStorage.setItem("firststatus", "yes");
                this.props.history.push({ pathname: "/Access/AccessList" });
              } else {
                console.log(JSON.stringify(postData));
                toast.error(data.Message, {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
              }
            }
          })
          .catch((error) => {
            console.log(error);
            // this.props.history.push({pathname:"/somethingwrong"})
          });
      } else {
        this.validator1.showMessages();
        this.forceUpdate();
      }
    }
  };

  searchEmployeeClear = () => {
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: "",
      StaffDetailslistArray: [],
      stafflistArraySpin: "none",
    });
  };

  GetSectionListData = (val) => {
    // alert('a')
    let postData = { Mode: "Section" };
    apiFetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/GetGGPMaster", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.props.getToken,
      },
      body: JSON.stringify(postData),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        if (data) {
          this.setState({ SectionlistArray: data.MasterList });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };
  chekceff = (sel) => {
    this.setState({ checkmulti: sel });
    console.log(JSON.stringify(this.state.checkmulti));
  };

  loginemployeename = () => {
    // alert('a')
    this.setState({ stafflistArraySpin: "", StaffDetailslistArray: [] });
    let postData = {
      EmployeeId: this.props.UserId,
      Name: this.state.popupEmployeeName,
      Section: this.state.popupSection,
    };
    apiFetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/GetStaffDetails", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.props.getToken,
      },
      body: JSON.stringify(postData),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        //console.log(data)
        if (data) {
          this.setState({
            Verifiedby: this.props.UserId,
            Verifiedbyname: data.StaffDetails[0].Name,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  searchEmployee = () => {
    // alert('a')
    this.setState({ stafflistArraySpin: "", StaffDetailslistArray: [] });
    let postData = {
      EmployeeId: this.state.popupEmployeeId,
      Name: this.state.popupEmployeeName,
      Section: this.state.popupSection,
    };
    apiFetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/GetStaffDetails", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.props.getToken,
      },
      body: JSON.stringify(postData),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        //console.log(data)
        if (data) {
          this.setState({
            StaffDetailslistArray: data.StaffDetails,
            stafflistArraySpin: "none",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  getInspectedbyshow = () => {
    this.setState({
      Inspectedbypopup: true,
      popupEmployeeId: "",
      popupEmployeeName: "",
      stafflistArraySpin: "none",
    });
  };

  getInspectedbyhide = () => {
    this.setState({
      Inspectedbypopup: false,
      popupEmployeeId: "",
      popupEmployeeName: "",
    });
  };

  getInspectedbyDetails = (id, name) => {
    this.setState({
      Inspectedby: id,
      Inspectedbyname: name,
      Inspectedbypopup: false,
    });
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: "",
      StaffDetailslistArray: [],
    });
  };

  handleChange = (e) => {
    switch (e.target.name) {
      case "popupEmployeeId":
        this.setState({ popupEmployeeId: e.target.value });
        break;
      case "popupEmployeeName":
        this.setState({ popupEmployeeName: e.target.value });
        break;
      case "status":
        this.setState({ activestatus: e.target.value });
        break;

      case "Role":
        this.setState({ Role: e.target.value });
        break;

      case "Active":
        this.setState({ Active: e.target.value });
        break;

      default:
        break;
    }
  };

  multicustodian = (selectedOption) => {
    let selectedValues = [];
    for (let i = 0; i < selectedOption.length; i++) {
      selectedValues.push(selectedOption[i].value);
    }
    this.setState({ Custodian: selectedValues.toString() });
  };

  handleSelectFormFields = (selectedOption) => {
    switch (selectedOption.id) {
      case "popupSection":
        this.setState({ popupSection: selectedOption.value });
        break;
      default:
        break;
    }
  };

  render() {
    let sectionOptionList = [];
    if (this.state.SectionlistArray) {
      this.state.SectionlistArray.map((data) => {
        let sData = { id: "popupSection", label: data.Code, value: data.Code };
        sectionOptionList.push(sData);
        return null;
      });
    }

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item
            href={process.env.REACT_APP_ENV + "/Access/AccessList"}>
            Access Privilege
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Create</Breadcrumb.Item>
        </Breadcrumb>
        <div className="content-area shadow p-3 mb-5 bg-white rounded">
          <h2 className="fs-title mb-2 mb-sm-4"> Access Privilege</h2>
          <section className="p-3">
            <div className="form-group row">
              <label for="" className="col-sm-2 col-form-label text-muted">
                Role
              </label>
              <div className="col-sm-3">
                <div className="form-group">
                  <select
                    className="form-control classic classicSelect"
                    name="Role"
                    value={this.state.Role}
                    onChange={this.handleChange}>
                    <option> Please select </option>
                    <option> SecurityAdmin</option>
                    <option> SecurityOfficer</option>
                    <option> FocalAdmin</option>
                  </select>
                </div>
                {this.validator.message("Role", this.state.Role, "required")}
              </div>
            </div>

            {(() => {
              if (this.state.Role !== "FocalAdmin") {
                console.log(this.state.Role);
                return (
                  <>
                    <div className="form-group row mb-2">
                      <label
                        for="auth-name"
                        className="col-sm-2 col-form-label text-muted">
                        Employee
                      </label>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            readOnly={true}
                            onClick={this.getInspectedbyshow}
                            value={this.state.Inspectedby}
                          />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <div className="input-group mb-2 mr-sm-2">
                            <input
                              type="text"
                              className="form-control"
                              id=""
                              placeholder=""
                              onClick={this.getInspectedbyshow}
                              readOnly={true}
                              value={this.state.Inspectedbyname}
                            />
                            <div className="input-group-prepend">
                              <div className="input-group-text">
                                <i
                                  className="fa fa-search text-muted"
                                  onClick={this.getInspectedbyshow}>
                                  {" "}
                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-2">
                      <div className="col-sm-2"> </div>
                      <div className="col-sm-5">
                        {this.validator.message(
                          "Physical Inspected By",
                          this.state.Inspectedby,
                          "required"
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label
                        for=""
                        className="col-sm-2 col-form-label text-muted">
                        {" "}
                        Status{" "}
                      </label>
                      <div className="col-sm-6">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="active-s"
                            type="radio"
                            name="status"
                            defaultChecked
                            value="1"
                            onChange={this.handleChange}
                          />
                          <label
                            className="form-check-label text-muted"
                            for="active-s">
                            {" "}
                            Active{" "}
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="inactive-s"
                            type="radio"
                            name="status"
                            value="0"
                            onChange={this.handleChange}
                          />
                          <label
                            className="form-check-label text-muted"
                            for="inactive-s">
                            {" "}
                            In-Active{" "}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-2">
                      <div className="col-sm-2"> </div>
                      <div className="col-sm-5">
                        {this.validator.message(
                          "Verified By",
                          this.state.activestatus,
                          "required"
                        )}
                      </div>
                    </div>
                  </>
                );
              } else {
                console.log(this.state.Role);
                return (
                  <>
                    <div className="form-group row mb-2">
                      <label
                        for="auth-name"
                        className="col-sm-2 col-form-label text-muted">
                        Employee
                      </label>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            readOnly={true}
                            onClick={this.getInspectedbyshow}
                            value={this.state.Inspectedby}
                          />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <div className="input-group mb-2 mr-sm-2">
                            <input
                              type="text"
                              className="form-control"
                              id=""
                              placeholder=""
                              onClick={this.getInspectedbyshow}
                              readOnly={true}
                              value={this.state.Inspectedbyname}
                            />
                            <div className="input-group-prepend">
                              <div className="input-group-text">
                                <i
                                  className="fa fa-search text-muted"
                                  onClick={this.getInspectedbyshow}>
                                  {" "}
                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-2">
                      <div className="col-sm-2"> </div>
                      <div className="col-sm-5">
                        {this.validator1.message(
                          "Physical Inspected By",
                          this.state.Inspectedby,
                          "required"
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label
                        for=""
                        className="col-sm-2 col-form-label text-muted">
                        Custodian for
                      </label>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <Select
                            options={sectionOptionList}
                            closeMenuOnSelect={false}
                            isMulti
                            onChange={this.multicustodian}
                          />
                        </div>
                        {this.validator1.message(
                          "Custodian",
                          this.state.Custodian,
                          "required"
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label
                        for=""
                        className="col-sm-2 col-form-label text-muted">
                        {" "}
                        Status{" "}
                      </label>
                      <div className="col-sm-6">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="active-s"
                            type="radio"
                            name="status"
                            defaultChecked
                            value="1"
                            onChange={this.handleChange}
                          />
                          <label
                            className="form-check-label text-muted"
                            for="active-s">
                            {" "}
                            Active{" "}
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="inactive-s"
                            type="radio"
                            name="status"
                            value="0"
                            onChange={this.handleChange}
                          />
                          <label
                            className="form-check-label text-muted"
                            for="inactive-s">
                            {" "}
                            In-Active{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-2">
                      <div className="col-sm-2"> </div>
                      <div className="col-sm-5">
                        {this.validator1.message(
                          "Verified By",
                          this.state.activestatus,
                          "required"
                        )}
                      </div>
                    </div>
                  </>
                );
              }
            })()}

            <div className="col-lg-12">
              <div className="col-lg-12 text-center">
                <button
                  type="button"
                  className="btn btn-primary-01 px-5"
                  onClick={this.saveaccess}>
                  {" "}
                  Add
                </button>
              </div>
            </div>
          </section>
        </div>

        {/* <div className="content-area shadow p-3 mb-5 bg-white rounded">
                <section className="p-3">
                  <div className="table-responsive"> 
                    <table className="table table-hover">
                      <thead className="thead-lightBlue">
                        <tr>
                          <th scope="col"> Role </th>
                          <th scope="col"> Employee ID  </th>
                          <th scope="col"> Name  </th>
                          <th scope="col"> Cost Center/Dept </th>
                          <th scope="col"> Custodian </th>
                          <th scope="col"> Created By </th>
                          <th scope="col"> Created Date Time </th>
                          <th scope="col"> Modified by </th>
                          <th scope="col"> Modified Date </th>
                          <th scope="col"> Action </th>
                          <th scope="col" className="position-relative"> 
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {this.state.accesslistitem.map((item, index) => (  
                      <tr  className="cursor-pointer">  
                          <td> {item.Role} </td>
                          <td> {item.EmployeeID} </td>
                          <td> {item.EmployeeName} </td>
                          <td> {item.CostCenter} </td>
                          <td> {item.Custodian} </td>
                          <td> <div>{item.CreatedBy} - {item.CreatedByName}</div></td>
                          <td> { ((item.CreatedDate) ? moment(item.CreatedDate).format("DD-MM-yyyy HH:mm:ss") : "")} </td>
                          <td> <div>{item.ModifiedBy} - {item.ModifiedByName} </div> </td>
                          <td> { ((item.ModifiedDate) ? moment(item.ModifiedDate).format("DD-MM-yyyy HH:mm:ss") : "")} </td>
                          <td scope="col"> 
                         <img className="action-right-space mouse-pointer" style={{width: "25px"}} src={process.env.REACT_APP_ENV +"/assets/images/icons/action/edit-solid.svg"} data-tip="Edit" alt="Metro Flow Tree"  data-tip="Edit"/>
                         <img className="action-right-space mouse-pointer" src={process.env.REACT_APP_ENV +"/assets/images/icons/action/awesome-eye.svg"} alt="View"  data-tip="View"/>
                        <img className="action-right-space mouse-pointer" style={{width: "25px"}} src={process.env.REACT_APP_ENV +"/assets/images/icons/action/trash-2.svg"} alt="Close" data-tip="Delete"/>
                          </td>
                    </tr>
                  ))}  
                         
                        
                      </tbody>
                    </table>
                  </div>
                </section>
              </div> */}
        <Modal show={this.state.Inspectedbypopup} size="lg">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      Autocomplete="off"
                      className="form-control"
                      name="popupEmployeeId"
                      value={this.state.popupEmployeeId}
                      onChange={this.handleChange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      Autocomplete="off"
                      className="form-control"
                      name="popupEmployeeName"
                      value={this.state.popupEmployeeName}
                      onChange={this.handleChange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted">
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      options={sectionOptionList}
                      onChange={this.handleSelectFormFields}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={() => this.searchEmployeeClear()}>
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.searchEmployee}>
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>
            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.StaffDetailslistArray.map((staff, index) => (
                      <tr
                        onClick={() =>
                          this.getInspectedbyDetails(
                            staff.EmployeeId,
                            staff.Name
                          )
                        }
                        className="cursor-pointer">
                        <td>
                          {" "}
                          <p>
                            {" "}
                            <span className="material-icons-outlined select-employee-icon">
                              {" "}
                              how_to_reg{" "}
                            </span>{" "}
                          </p>{" "}
                        </td>
                        <td> {staff.EmployeeId} </td>
                        <td> {staff.Name} </td>
                        <td> ({staff.Account}) </td>
                        <td> {staff.Email} </td>
                        <td> {staff.Section} </td>
                        <td> {staff.SectionName} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.StaffDetailslistArray.length <= 0 &&
                    this.state.stafflistArraySpin === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
                <p className="text-center">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{ display: this.state.stafflistArraySpin }}
                    className="text-center"
                  />
                </p>
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.getInspectedbyhide()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <FloatingButton />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(Accessprivilegecreate);
